function loadView(view) {
    // console.log("here==>",`../views/${view}.vue`);
    
    return () => import(`../views/${view}.vue`);
}

const Login = loadView("Login");
const Unauthorized = loadView("Unauthorized");
const PageNotFound = loadView("PageNotFound");
const Index = loadView("Index");
const Dashboard = loadView("Dashboard");
// import CustomerList from '../views/Customer/List.vue'

const Staff = loadView("Staff");
const FormStaff = loadView("FormStaff");

const Label = loadView("Label");
const LabelDetail = loadView("LabelDetail");
const LabelForm = loadView("LabelForm");

const ParcelTrack = loadView("ParcelTrack");
const IndexByStatus = loadView("IndexByStatus");
const Clearance = loadView("Clearance");
const CODPageDetail = loadView("CODPageDetail");
const CreditDetail = loadView("CreditDetail");
const ExpenseRecord = loadView("ExpenseRecord");
const TrackByDate = loadView("TrackByDate");

const Report = loadView("Report");

const Customer = loadView("CustomerList");
const CustomerDetail = loadView("CustomerDetail");

const CallList = loadView("CallList");
const CallListDetail = loadView("CallListDetail");
const ShippingReportCsvList = loadView("ShippingReportCsvList");
const PickupRequest = loadView("PickupRequest");
const PickupRequestForm = loadView("PickupRequestForm");
const CodClearance = loadView("CodClearance");
const CodClearanceDetail = loadView("CodClearanceDetail");
const CodClearanceReadyDetail = loadView("CodClearanceReadyDetail");
const CodClearanceReadyPendingList = loadView("CodClearanceReadyPendingList");
const ReturnCollectionDetail = loadView("ReturnCollectionDetail");
const GateSubmitMerchantClearanceReadyDetail = loadView("GateSubmitMerchantClearanceReadyDetail");
const GateSubmitMerchantClearanceCompleteDetail = loadView("GateSubmitMerchantClearanceCompleteDetail");
const ClearanceFromMMPostCollectionDetail = loadView("ClearanceFromMMPostCollectionDetail");
const CreditCollectionDetail = loadView("CreditCollectionDetail");
const LabelAction = loadView("LabelAction");
const ApiIntegration = loadView("ApiIntegration");

export default [
    {
        path: "/api-integration",
        component: ApiIntegration,
        name: "apiIntegration",
        meta: {
            permissions: "global",
            auth: true,
        },
    },
    {
        path: "/",
        component: Index,
        name: "index",
        meta: {
            permissions: "global",
            auth: true,
        },
    },
    {
        path: "/dashboard",
        component: Dashboard,
        name: "dashboard",
        meta: {
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "index",
                    name: "dashboard",
                    status: false,
                },
            ],
        },
    },

    {
        path: "/login",
        component: Login,
        name: "login",
        meta: {
            permissions: "global",
            guest: true,
            bodyClass: "login",
        },
    },
    {
        path: "/developer/active-users",
        name: "active-users-monitor",
        component: loadView("ActiveUsersMonitor"),
        meta: {
            // public — login ဝင်ထား/မဝင်ထား နှစ်မျိုးလုံး ဖွင့်ရတယ် (helper.isPublicRoute)။
            // Page ကိုယ်တိုင်မှာ data မပါဘဲ data အားလုံးကို viewer API ကနေ ယူတာမို့
            // တကယ့်ဂိတ်က backend ရဲ့ za-developer header key (za_active_users.viewer.middleware)
            // ဖြစ်တယ် — key မပါရင် API က 401 ပြန်ပြီး ဘာ data မှ မမြင်ရဘူး။
            // Login ဝင်သူတွေက merchant (customer) တွေမို့ sidebar မှာ link မထည့်ဘဲ URL နဲ့သာ ဖွင့်တယ်။
            public: true,
        },
    },
    {
        path: "/403",
        component: Unauthorized,
        name: "unauthorized",
        meta: {
            permissions: "global",
            auth: true,
        },
    },
    {
        path: "/404",
        name: "404",
        component: PageNotFound,
        meta: {
            permissions: "global",
            auth: true,
        },
    },
    {
        path: "/staff/:tab",
        name: "staff",
        component: Staff,
        meta: {
            title: "Staffs",
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "staff",
                    name: "staff",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/new-staff",
        name: "staff-create",
        component: FormStaff,
        meta: {
            title: "New Staff",
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "staff",
                    name: "staff",
                    status: true,
                },
                {
                    route: "staff-create",
                    name: "new_staff",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/edit-staff/:staffID",
        name: "staff-edit",
        component: FormStaff,
        meta: {
            title: "Edit Staff",
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "staff",
                    name: "staff",
                    status: true,
                },
                {
                    route: "staff-edit",
                    name: "edit_staff",
                    status: false,
                },
            ],
        },
        props: (route) => {
            return {
                isEditing: true,
            };
        },
    },
    {
        path: "/track-by-date",
        name: "track_bydate",
        component: TrackByDate,
        meta: {
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "track_bydate",
                    name: "track_by_date",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/label/:tab",
        name: "label",
        component: Label,
        meta: {
            title: "Labels",
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "label",
                    name: "label",
                    status: true,
                },
            ],
        },
    },
    {
        path: "/label/create",
        name: "label-create",
        component: LabelForm,
        meta: {
            title: "New Label",
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "label-create",
                    name: "new_label",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/label/detail/:labelId",
        name: "label.detail",
        component: LabelDetail,
        meta: {
            title: "Labels",
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "label",
                    name: "label",
                    status: true,
                },
                {
                    route: "label.detail",
                    name: "detail",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/label/print/:id",
        name: "label.print",
        meta: {
            permissions: "global",
            auth: true,
        },
    },
    {
        path: "/expense-record",
        component: ExpenseRecord,
        name: "expense-record",
        meta: {
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "expense-record",
                    name: "expense_records",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/parcels/:tab",
        name: "parcel.indexbystatus",
        component: IndexByStatus,
        meta: {
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "parcel.indexbystatus",
                    name: "parcels",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/parcel-track/list",
        name: "parcel.track",
        component: ParcelTrack,
        meta: {
            title: "Parcels",
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "parcel.track",
                    name: "parcels",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/parcel-detail/:id",
        name: "parcel.show",
        component: ParcelTrack,
        meta: {
            title: "Parcels",
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "parcel.track",
                    name: "parcels",
                    status: true,
                },
                {
                    route: "parcel.show",
                    name: "detail",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/track-by-date/get-excel",
        name: "dashboard.getexcel",
        meta: {
            permissions: "dashboard-view",
            auth: true,
        },
    },
    {
        path: "/cod/:status",
        name: "clearance",
        component: Clearance,
        meta: {
            title: "Parcels",
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "clearance",
                    name: "clearance",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/print/clearance",
        name: "print.clearance",
        meta: {
            title: "COD Report",
            permissions: "global",
            auth: true,
        },
    },
    {
        path: "/cod-page-detail/:id",
        name: "cod.page",
        component: CODPageDetail,
        meta: {
            permissions: "dashboard-view",
            auth: true,
            breadcrumbs: [
                {
                    route: "clearance",
                    name: "clearance",
                    status: true,
                },
                {
                    route: "cod.page",
                    name: "detail",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/credit/detail",
        name: "credit-detail",
        component: CreditDetail,
        meta: {
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "credit-detail",
                    name: "detail",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/clearance/excel/:id/:hash",
        name: "clearance.excel",
        meta: {
            permissions: "dashboard-view",
            auth: true,
        },
        props: true,
    },
    {
        path: "/package/print/:id/:hash",
        name: "package.print",
        meta: {
            permissions: "dashboard-view",
            auth: true,
        },
    },
    {
        path: "/report/:tab",
        name: "report",
        component: Report,
        meta: {
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "report",
                    name: "report",
                    status: true,
                },
            ],
        },
    },
    {
        path: "/customer/list",
        name: "customer.list",
        component: Customer,
        meta: {
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "customer.list",
                    name: "customer",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/customer/:customerId",
        name: "customer.detail",
        component: CustomerDetail,
        meta: {
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "customer.list",
                    name: "customer",
                    status: true,
                },
                {
                    route: "customer.detail",
                    name: "detail",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/package/report/:hash",
        name: "package.report",
        meta: {
            permissions: "dashboard-view",
            auth: true,
        },
        props: true,
    },
    {
        path: '/call-list/:tab',
        name: 'call-list',
        component: CallList,
        meta: {
            permissions: 'global',
            auth: true,
            breadcrumbs: [
                {
                   route: "call-list",
                    name: "call_log",
                    status: true,
                }
            ]
        }
    },
    {
        path: "/call-list/:type/detail/:callID",
        component: CallListDetail,
        name: "call-list.detail",
        meta: {
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "call-list",
                    name: "call_log",
                    params: { tab: 'pending' },
                    status: true,
                },
                {
                    route: "call-list.detail",
                    name: "detail",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/shipping-report/csv/list",
        name: "shipping-report.csv-list",
        component: ShippingReportCsvList,
        meta: {
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "csv-app",
                    name: "cache_csv_list",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/pickup-request",
        name: "pickup-request",
        component: PickupRequest,
        meta: {
            permissions: "global",
            auth: true,
        },
    },
    {
        path: "/pickup-request/create",
        name: "pickup-request.form",
        component: PickupRequestForm,
        meta: {
            permissions: "global",
            auth: true,
        },
    },
    {
        path: "/cod-clearance",
        name: "cod-clearance.list",
        component: CodClearance,
        meta: {
            title: "Parcels",
            permissions: "global",
            auth: true,
            breadcrumbs: [
                {
                    route: "cod-clearance.list",
                    name: "clearance"
                },
            ],
        },
    },
    {
        path: "/cod-clearance-detail/:transactionId",
        name: "cod-clearance.detail",
        component: CodClearanceDetail,
        meta: {
            permissions: "dashboard-view",
            auth: true,
            breadcrumbs: [
                {
                    route: "cod-clearance.list",
                    name: "clearance",
                    status: true,
                },
                {
                    route: "cod-clearance.detail",
                    name: "cod_clearance_detail",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/cod-clearance/ready/pending",
        name: "cod-clearance-ready-list",
        component: CodClearanceReadyPendingList,
        meta: {
            permissions: "dashboard-view",
            auth: true,
            breadcrumbs: [
                {
                    route: "cod-clearance-ready-list",
                    name: "cod_clearance_ready_list",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/cod-clearance/ready/detail",
        name: "cod-clearance-ready-detail",
        component: CodClearanceReadyDetail,
        meta: {
            permissions: "dashboard-view",
            auth: true,
            breadcrumbs: [
                {
                    route: "cod-clearance-ready-detail",
                    name: "cod_clearance_ready_detail",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/acceptance/return/by_merchant_list/:collectionID",
        name: "return-collection.detail",
        component: ReturnCollectionDetail,
        meta: {
            permissions: "dashboard-view",
            auth: true,
            breadcrumbs: [
                {
                    route: "return-collection.detail",
                    name: "return_collection_detail",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/gate-submit/merchant-clearnce-ready/:merchantId/detail",
        name: "merchant-gate-submit-clearance-ready.detail",
        component: GateSubmitMerchantClearanceReadyDetail,
        meta: {
            permissions: "dashboard-view",
            auth: true,
            breadcrumbs: [
                {
                    route: "merchant-gate-submit-clearance-ready.detail",
                    name: "detail",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/clearance-from-mmpost/collection/:collectionID/detail",
        name: "clearance-from-mmpost.collection-detail",
        component: ClearanceFromMMPostCollectionDetail,
        meta: {
            permissions: "dashboard-view",
            auth: true,
            breadcrumbs: [
                {
                    route: "clearance-from-mmpost.collection-detail",
                    name: "detail",
                    status: false,
                },
            ],
        },
    },
    {
        path: "/credit/collection/:collectionID/detail",
        name: "credit-collection.detail",
        component: CreditCollectionDetail,
        meta: {
            permissions: "dashboard-view",
            auth: true,
            breadcrumbs: [
                {
                    route: "credit-collection.detail",
                    name: "detail",
                    status: false,
                },
            ],
        },
    },
    {
        path:"/label/detial/:labelId",
        name: "mmpost.shipping-status.detail",
        component: LabelAction,
        meta:{
            permissions: "dashboard-view",
            auth: true,
            breadcrumbs: [
                {
                    route: "mmpost.shipping-status",
                    name: "shipping_status_mmpost",
                    status: true,
                },
                {
                    route: "mmpost.shipping-status.detail",
                    name: "detail",
                    status: false,
                },
            ],
        }

    },
    {
        path: "/gate-submit/collection/:collectionId/detail",
        name: "merchant-gate-submit-clearance-complete.detail",
        component: GateSubmitMerchantClearanceCompleteDetail,
        meta: {
            permissions: "dashboard-view",
            auth: true,
            breadcrumbs: [
                {
                    route: "merchant-gate-submit-clearance-complete.detail",
                    name: "detail",
                    status: true,
                },
            ],
        },
    },
];
